import { Button } from '../components/ui/button';

/** Unknown hash route — do not silently fall through to Home. */
export function NotFound() {
  return (
    <main id="main-content" className="queue-page shell-recover">
      <header className="page-heading">
        <div>
          <span className="eyebrow">NOT FOUND</span>
          <h1>This page does not exist<span className="heading-dot">.</span></h1>
          <p>Check the link, or go back to Home.</p>
        </div>
      </header>
      <div className="shell-recover-actions">
        <Button asChild><a href="#home">Back to Home</a></Button>
      </div>
    </main>
  );
}
